<template>
    <v-container fill-height fluid>
      <v-row v-if="showAgenciaObjetivoDashboard">
        <v-col cols="12" class="pa-6 pb-0">
          <agencia-objetivo-dashboard />
        </v-col>
      </v-row>

      <gallery-menu :nav="getMenu"> </gallery-menu>
    </v-container>
</template>

<script>
import menuconfig from "@/menu-config/menu-config"
import GalleryMenu from "@/layout/GalleryMenu/GalleryMenu";
import AgenciaObjetivoDashboard from "@/modules/cobrox/components/AgenciaObjetivoDashboard/AgenciaObjetivoDashboard";
import AgenciaObjetivoProvider from "@/modules/cobrox/providers/AgenciaObjetivoProvider";

export default {
  name: 'HomePage',
  components: {AgenciaObjetivoDashboard, GalleryMenu},
  data(){
    return {
      menu: menuconfig,
      hasAgenciaObjetivoDashboardAgencia: false
    }
  },
  created() {

    this.$store.dispatch('loadSettings')

    if(this.$store.getters.me === null){
      this.$router.push({name: 'login'})
    } else {
      this.checkAgenciaObjetivoDashboard()
    }
  },
  computed: {
    showAgenciaObjetivoDashboard(){
      return (this.$store.getters.hasPermission('AGENCIAOBJETIVO_DASHBOARD') ||
          this.$store.getters.hasPermission('AGENCIAOBJETIVO_ADMIN_DASHBOARD')) &&
          this.hasAgenciaObjetivoDashboardAgencia
    },
    isRedmineIntegrationEnable(){
      return this.$store.getters.getSettingValue('RedmineIntegration')
    },
    getMenu() {
      return this.$store.getters.isRestoreSystemEnable ? this.menu : this.menu.filter( i => i.permission != 'RESTORE_SYSTEM')
    },
    redmineStatusList(){
      return this.$store.getters.getSettingValue('RedmineDashboardStatusList')
    }
  },
  methods: {
    checkAgenciaObjetivoDashboard(){
      if (!this.$store.getters.hasPermission('AGENCIAOBJETIVO_DASHBOARD') &&
          !this.$store.getters.hasPermission('AGENCIAOBJETIVO_ADMIN_DASHBOARD')) {
        this.hasAgenciaObjetivoDashboardAgencia = false
        return
      }

      AgenciaObjetivoProvider.hasAgenciaObjetivoDashboardAgencia()
          .then(r => {
            this.hasAgenciaObjetivoDashboardAgencia = !!r.data.hasAgenciaObjetivoDashboardAgencia
          })
          .catch(() => {
            this.hasAgenciaObjetivoDashboardAgencia = false
          })
    }
  }
}
</script>

<style scoped>

</style>
